export const TRANSFERS = "https://mobile.globalfarm.com.ar:8281/Users/Login?from=TRANSFER"
//export const PEDIDOS = "https://mobile.globalfarm.com.ar:8281/Users/Login?from=PEDIDO"
export const PORTALDROGUERIAS = "https://portaldroguerias.globalfarm.com.ar:8287/"


// WEBPACK FOOTER //
// ./src/config/urlLogins.js